import { withStyles } from '@material-ui/core';

import Menu from './component';
import styles from './styles';

export default withStyles(styles)(Menu);
